<template>
  <tr>
    <td>
      <!-- <router-link :to="'/FAQcategories/' + FAQcategory.slug + '/FAQs'"> -->
      {{ FAQcategory.title }}
      <!-- </router-link> -->
    </td>
    <td>
      <span v-if="FAQcategory.description">
        {{ FAQcategory.description }}
      </span>
      <span v-else> - </span>
    </td>
    <td v-if="FAQcategory.total_faqs != null">
      {{ FAQcategory.total_faqs }}
    </td>
    <td v-else>0</td>

    <!-- controls [update, delete] -->
    <td>
      <div class="btn-group">
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <a class="dropdown-item" @click="updateCategory">Update</a>
          <a class="dropdown-item text-danger" :data-count="FAQcategory.total_faqs" @click="deleteCategory">Delete</a>
        </ul>
      </div>
    </td>
  </tr>
</template>
<script>
  import categoryForm from "./form";

  export default {
    props: ["FAQcategory"],
    computed: {
      moderator: function () {
        if (typeof this.FAQcategory.moderator === "undefined") {
          return "unknown";
        }
        return this.FAQcategory.moderator;
      },

      description: function () {
        if (typeof this.FAQcategory.description === "undefined") {
          return "";
        }
        let desc = this.FAQcategory.description;
        if (desc.length > 100) {
          return desc.slice(0, 97) + "...";
        }
        return desc;
      },
    },
    methods: {
      updateCategory() {
        this.$store.dispatch("modal/update", {
          action: "update",
          formData: this.FAQcategory,
          title: this.FAQcategory.title,
          component: categoryForm,
        });
      },
      deleteCategory() {
        let count = event.target.dataset.count;
        if (count > 0) {
          this.$store.dispatch("message/update", {
            title: this.FAQcategory.title,
            body: "You can not Delete this Category Right now. First delete Relative FAQs! ",
            class: "warning",
          });
        } else {
          this.$store.dispatch("message/update", {
            title: this.FAQcategory.title,
            body: "Are you sure you want to delete this Category?",
            class: "danger",
            confirm: true,
          });
        }

        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          this.delete(this.FAQcategory);
          this.$store.dispatch("message/close");
        });
      },
      delete(FAQcategory) {
        this.$store
          .dispatch("faqcategories/deleteCategory", FAQcategory)
          .then((response) => {
            // send successful message
            this.$toast.success(response.data.message);
          })
          .catch((error) => {
            let response = error.response;
            this.$toast.error(response.data.message);
          });
      },
    },
  };
</script>
<style scoped>
  /* table tr td:nth-child(1) {
    width: 50% !important;
  }

  table tr td:nth-child(2) {
    width: 20% !important;
  } */

  table tr td:nth-child(3) {
    text-align: center;
  }

  table tr td:nth-child(4) {
    text-align: center;
  }
</style> 